import { Button } from 'antd';
import styled from '@emotion/styled';
import { useCallback } from 'react';
import { useSkipNav } from 'store/skip-nav';

export default function SkipNav(): JSX.Element {
  const { ref } = useSkipNav();
  const onClick = useCallback(() => {
    ref?.current?.focus();
  }, [ref]);
  return (
    <Container className='skip-to-content-container'>
      <Button onClick={onClick} className='skip-to-content-button'>
        Skip to content
      </Button>
    </Container>
  );
}
const Container = styled.div({
  position: 'relative',
  height: 0,
});
